import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TabMenu from "../components/companies/TabMenu";
import { fetchCustomerBilling } from "../api/pocketbase";

const PaymentsPage = () => {
  const { id } = useParams();
  const [customer, setCustomer] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadBilling = async () => {
      try {
        const record = await fetchCustomerBilling(id);
        setCustomer(record);
      } catch (err) {
        console.error("Error loading payment details:", err);
        setError("Failed to load payment details.");
      }
    };
    if (id) loadBilling();
  }, [id]);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="space-y-6 px-3 py-4 sm:px-6 sm:py-6">
        <TabMenu />
        <div className="rounded-xl bg-white p-4 shadow-sm sm:p-6">
          <h2 className="text-lg font-semibold text-gray-900">Payments</h2>
          <p className="mt-1 text-sm text-gray-500">
            dbap has no payments collection. Stripe identity for this customer is shown below.
          </p>
          {error ? (
            <p className="mt-4 text-sm text-red-600">{error}</p>
          ) : !customer ? (
            <p className="mt-4 text-sm text-gray-500">Loading...</p>
          ) : (
            <div className="mt-6 space-y-4">
              <div className="rounded-lg border border-gray-100 p-4">
                <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">Company</p>
                <p className="mt-1 text-sm text-gray-900">{customer.CompanyName || "-"}</p>
              </div>
              <div className="rounded-lg border border-gray-100 p-4">
                <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">Stripe customer id</p>
                <p className="mt-1 break-all text-sm text-gray-900">{customer.stripeCustId || "Not set"}</p>
              </div>
              <div className="rounded-lg border border-gray-100 p-4">
                <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">Account status</p>
                <p className="mt-1 text-sm text-gray-900">{customer.active === false ? "Inactive" : "Active"}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentsPage;
